export enum EmployeeStatusEnum {
    Active = 1,
    Inactive = 2,
    Pending = 3,
    "Pending Invite" = 0,
    Terminated = 4
}
